import { Button, DatePicker, Input, Modal, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import CustomersDropdown from '../../CustomersDropdown'
import dayjs from 'dayjs'
import ServicesAliasDropdown from '../../ServicesAliasDropdown'
import { toast } from 'react-toastify'
import Loader from '../../../pages/pages/loader'
import { useCreateCustomerCampaignServiceMutation } from '../../../redux/apis/campaignsManagement/customerCampaign/cMCustomerCampaignApiSlice'

const AddServiceCampaignModal = ({ data, refetch, open, setOpen, holder }) => {
  const [create, { isLoading, error, isSuccess }] =
    useCreateCustomerCampaignServiceMutation()
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      campaign: data?.id || '',
      is_takedown: holder?.is_takedown ? true : false,
      customer: holder?.customer?.id || null,
      end_date: holder?.end_date || '',
      start_date: holder?.start_date || '',
      service_frequency: holder?.service_frequency || '',
      service_alias: holder?.service_alias || null,
      status: true,
    },

    validationSchema: Yup.object({
      is_takedown: Yup.boolean().required('Please Select Campaign Mode'),
      customer: Yup.number().required('Please Select Customer'),
      end_date: Yup.string().required('Please Enter End date'),
      start_date: Yup.string().required('Please Enter Start date'),
      service_frequency: Yup.string().required('Please Enter Frequency'),
      service_alias: Yup.string().required('Please Select Service')
    }),

    onSubmit: async values => {
      try {
        await create(values)
      } catch (error) {
        console.error(error)
      }
    }
  })

  useEffect(() => {
    if (error?.data) {
      const errors = error.data.errors

      if (errors && typeof errors === 'object') {
        const errorMessages = Object.values(errors).flat()
        errorMessages.forEach(message => {
          toast.error(message)
        })
      } else if (error.data.message) {
        // fallback in case errors field is missing but a general message exists
        toast.error(error.data.message)
      }
    }
  }, [error])

  useEffect(() => {
    if (isSuccess) {
      toast.success('Campaign Service Added!')
      refetch()
      setOpen(false)
      validation.resetForm()
    }
  }, [isSuccess])
  return (
    <div className='w-full'>
      <Loader isLoading={isLoading} />
      <div className='flex'>
        <button
          className='btn btn-outline-theme flex-1'
          onClick={() => {
            setOpen(true)
          }}
        >
          Add New Service
        </button>
      </div>
      <Modal
        open={open}
        title='Add New Service'
        onCancel={() => setOpen(false)}
        footer={[
          <Button key='back' onClick={() => setOpen(false)}>
            Cancel
          </Button>,
          <Button
            key='submit'
            type='primary'
            onClick={() => {
              if (Object.keys(validation.errors).length !== 0) {
                Object.keys(validation.errors).map(key => {
                  // toast.error(validation.errors[key]);
                })
                return
              }
              validation.handleSubmit()
            }}
          >
            Submit
          </Button>
        ]}
      >
        <div className='gap-8 '>
          <div>
            <CustomersDropdown
              onBlur={validation.handleBlur}
              onChange={e => {
                validation.setFieldValue('customer', e)
              }}
              value={validation.values?.customer}
            />
            {validation.touched.customer && validation.errors.customer ? (
              <p className='text-danger'>{validation.errors.customer}</p>
            ) : null}
          </div>
          <div className=' mb-3  flex-1'>
            <label className="form-label">Start Date</label>
            <br />
            <DatePicker
              onBlur={validation.handleBlur}
              name='start_date'
              style={{ width: '100%' }}
              value={
                validation.values?.start_date
                  ? dayjs(validation.values?.start_date)
                  : ''
              }
              onChange={(e, date) =>
                validation.setFieldValue('start_date', date)
              }
            />
            {validation.touched.start_date && validation.errors.start_date ? (
              <p className='text-danger'>{validation.errors.start_date}</p>
            ) : null}
          </div>
          <div className=' mb-3  flex-1'>
            <label className="form-label">End Date</label>
            <br />
            <DatePicker
              name='end_date'
              style={{ width: '100%' }}
              value={
                validation.values?.end_date
                  ? dayjs(validation.values?.end_date)
                  : ''
              }
              onBlur={validation.handleBlur}
              onChange={(e, date) => validation.setFieldValue('end_date', date)}
            />
            {validation.touched.end_date && validation.errors.end_date ? (
              <p className='text-danger'>{validation.errors.end_date}</p>
            ) : null}
          </div>
          <div className=' mb-3 flex-1'>
            <label className="form-label">Mode</label>
            <br />
            <Select
              className={''}
              style={{
                width: '100%'
              }}
              onChange={e => {
                validation.setFieldValue('is_takedown', e)
              }}
              onBlur={validation.handleBlur}
              value={validation.values?.is_takedown}
              options={[
                { label: 'Take Down', value: true },
                { label: 'Monitoring', value: false }
              ]}
            />
            {validation.touched.is_takedown && validation.errors.is_takedown ? (
              <p className='text-danger'>{validation.errors.is_takedown}</p>
            ) : null}
          </div>
          <ServicesAliasDropdown
            onBlur={validation.handleBlur}
            onChange={(e) => {
              validation.setFieldValue('service_alias', e)
            }}
            value={validation.values?.service_alias}
            service_category='1'
            service_type="campaign"
          />
          {validation.touched.service_alias && validation.errors.service_alias ? (
            <p className='text-danger'>{validation.errors.service_alias}</p>
          ) : null}
          <div className=' mb-3 flex-1 '>
            <label className="form-label">Frequancy</label>
            <Input
              type='text'
              name='Frequancy'
              onBlur={validation.handleBlur}
              onChange={e =>
                validation.setFieldValue('service_frequency', e.target.value)
              }
              value={validation.values?.service_frequency}
            />
            {validation.touched.service_frequency &&
            validation.errors.service_frequency ? (
              <p className='text-danger'>
                {validation.errors.service_frequency}
              </p>
            ) : null}
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default AddServiceCampaignModal
